import { createApp } from "./createApp.js";
import { registerClientOnlyPlugins } from "./client-only-plugins.js";
import { checkAndClearLocalStorageOnBuildChange } from "./helpers/buildVersion.js";
import { initGoogleTagManager } from "./helpers/gtm.js";
import { initClientErrorTracking } from "./helpers/errorTracking.js";
import { initStaleChunkReload } from "./helpers/chunkReload.js";

initGoogleTagManager();
initClientErrorTracking();

function hydratePinia(pinia) {
    const el = document.getElementById("pinia-state");
    if (!el?.textContent) return;
    const raw = el.textContent.trim();
    if (!raw || raw === "<!--pinia-state-->") return;
    try {
        const fromServer = JSON.parse(raw);
        if (fromServer && typeof fromServer === "object") {
            // Preserve browser-persisted carts/local user context; SSR state may be empty.
            delete fromServer.store;
            delete fromServer.fastDeliveryCart;
            delete fromServer.auth;
            pinia.state.value = fromServer;
        }
    } catch {
        /* ignore */
    }
}

checkAndClearLocalStorageOnBuildChange().then(() => {
    const { app, router, pinia } = createApp({ ssr: false });
    registerClientOnlyPlugins(app);
    initStaleChunkReload(router);
    hydratePinia(pinia);
    router.isReady().then(() => {
        const el = document.getElementById("app");
        const hasSsrMarkup =
            el &&
            el.innerHTML.trim().length > 0 &&
            !el.innerHTML.includes("<!--app-html-->");
        app.mount("#app", hasSsrMarkup);
    });
});
/* OneSignal / pixels: public/deferred-trackers.js (after load + idle) */
